module.exports = __webpack_public_path__ + "src/assets/img/m14.80854db4.svg";